(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kifl-launch-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.kifl-launch');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;
    sections.forEach((section) => {
      const visual = section.querySelector('.kifl-launch__visual');
      if (!visual || visual.dataset.motionReady === 'true') return;
      visual.dataset.motionReady = 'true';
      section.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;
        const bounds = section.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width - .5) * 14;
        const y = ((event.clientY - bounds.top) / bounds.height - .5) * 10;
        visual.style.setProperty('--mx', `${x}px`);
        visual.style.setProperty('--my', `${y}px`);
      });
      section.addEventListener('pointerleave', () => {
        visual.style.setProperty('--mx', '0px');
        visual.style.setProperty('--my', '0px');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kifl-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-kifl-recent-section]');
    const source = section?.querySelector('[data-kifl-current-product]');
    const grid = section?.querySelector('[data-kifl-recent-grid]');
    if (!section || !source || !grid) return;
    let current;
    let history = [];
    try { current = JSON.parse(source.textContent); history = JSON.parse(localStorage.getItem('kiflRecentlyViewed') || '[]'); } catch (error) { return; }
    const visible = history.filter((item) => item.id !== current.id).slice(0, 4);
    visible.forEach((item) => {
      const card = document.createElement('a');
      card.className = 'kifl-recent__card'; card.href = item.url;
      const image = document.createElement('img');
      image.src = item.image; image.alt = item.title; image.loading = 'lazy'; image.width = 600; image.height = 600;
      const content = document.createElement('div'); content.className = 'kifl-recent__content';
      const title = document.createElement('p'); title.className = 'kifl-recent__title'; title.textContent = item.title;
      const price = document.createElement('span'); price.className = 'kifl-recent__price'; price.textContent = item.price;
      content.append(title, price); card.append(image, content); grid.append(card);
    });
    if (visible.length) section.hidden = false;
    history = [current, ...history.filter((item) => item.id !== current.id)].slice(0, 8);
    try { localStorage.setItem('kiflRecentlyViewed', JSON.stringify(history)); } catch (error) {}
  })();

  } catch(e) { console.error(e); }
})();
})();
